import { useTranslation } from 'react-i18next'

type Role = {
  id: string | null
  displayName: string | null
  description?: string | null
}

const ROLE_ID_TO_KEY = {
  'org:owner': 'owner',
  'org:member': 'member'
} as const

type RoleId = keyof typeof ROLE_ID_TO_KEY

const isKnownRoleId = (id: string): id is RoleId => id in ROLE_ID_TO_KEY

export const useTranslatedRole = () => {
  const { t, i18n } = useTranslation()

  const translateRole = <T extends Role>(role: T): T => {
    const key = role.id && isKnownRoleId(role.id) ? ROLE_ID_TO_KEY[role.id] : undefined
    if (!key) {
      return role
    }

    const translatedName = i18n.exists(`roles.${key}.displayName`) ? t(`roles.${key}.displayName`) : role.displayName

    const translatedDescription = i18n.exists(`roles.${key}.description`)
      ? t(`roles.${key}.description`)
      : role.description

    return {
      ...role,
      displayName: translatedName,
      ...(role.description !== undefined ? { description: translatedDescription } : {})
    }
  }

  return { translateRole }
}
